// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"SecondaryTooltip_tooltip__1OkZT","tooltipText":"SecondaryTooltip_tooltipText__2UH2x"};